import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import { GeneralPermissionCode } from "@odata/GeneratedEnums";
import ItemTemplates from "pages/admin/itemTemplates";
import React, { lazy } from "react";

import {
    ROUTE_COMPANY_ROLES,
    ROUTE_DOCUMENT_ITEM_TEMPLATES,
    ROUTE_SUBSCRIPTIONS_EXTENSIONS,
    ROUTE_SUBSCRIPTIONS_INVOICING,
    ROUTE_SUBSCRIPTIONS_PAYMENTS,
    ROUTE_SUBSCRIPTIONS_PLAN,
    ROUTE_SYSTEM_ROLES,
    ROUTE_USERS,
    ROUTE_VAT
} from "../routes";
import FormRoute from "../routes/FormRoute";
import PrivateRoute from "../routes/PrivateRoute";

const CompanyRoles = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/companyRoles"));
const GeneralRoles = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/generalRoles"));
const VatRules = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/vatRules/VatRules"));
const Plan = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/subscriptions/subpages/Plan"));
const Invoicing = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/subscriptions/subpages/Invoicing"));
const Extensions = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/subscriptions/subpages/Extensions"));
const BillingPaymentHistory = lazy(() => import(/* webpackChunkName: "administration" */"@pages/admin/subscriptions/subpages/BillingPayments"));
const Users = lazy(() => import(/* webpackChunkName: "administration" */"../pages/admin/users"));

export default function administrationBundle(): React.ReactElement[] {
    return [
        <FormRoute path={ROUTE_USERS}
                   key={ROUTE_USERS}
                   entityType={EntityTypeName.User}
                   GPs={GeneralPermissionCode.OrganizationManagement}
                   page={Users}/>,
        <FormRoute
                path={ROUTE_COMPANY_ROLES}
                key={ROUTE_COMPANY_ROLES}
                entityType={EntityTypeName.CompanyRole}
                GPs={GeneralPermissionCode.OrganizationManagement}
                page={CompanyRoles}/>,
        <FormRoute
                path={ROUTE_SYSTEM_ROLES}
                key={ROUTE_SYSTEM_ROLES}
                entityType={EntityTypeName.GeneralRole}
                GPs={GeneralPermissionCode.OrganizationManagement}
                page={GeneralRoles}/>,
        <FormRoute path={ROUTE_VAT}
                   key={ROUTE_VAT}
                   entityType={EntityTypeName.VatClassification}
                   GPs={GeneralPermissionCode.TemplateManagement}
                   page={VatRules}/>,
        <FormRoute path={ROUTE_DOCUMENT_ITEM_TEMPLATES}
                   key={ROUTE_DOCUMENT_ITEM_TEMPLATES}
                   entityType={EntityTypeName.ItemTemplate}
                   GPs={GeneralPermissionCode.TemplateManagement}
                   page={ItemTemplates}/>,
        <PrivateRoute
                path={ROUTE_SUBSCRIPTIONS_PLAN}
                key={ROUTE_SUBSCRIPTIONS_PLAN}
                GPs={GeneralPermissionCode.OrganizationManagement}
                component={Plan}/>,
        <PrivateRoute
                path={ROUTE_SUBSCRIPTIONS_INVOICING}
                key={ROUTE_SUBSCRIPTIONS_INVOICING}
                GPs={GeneralPermissionCode.OrganizationManagement}
                component={Invoicing}/>,
        <PrivateRoute
                path={ROUTE_SUBSCRIPTIONS_EXTENSIONS}
                key={ROUTE_SUBSCRIPTIONS_EXTENSIONS}
                GPs={GeneralPermissionCode.OrganizationManagement}
                component={Extensions}/>,
        <PrivateRoute
            path={ROUTE_SUBSCRIPTIONS_PAYMENTS}
            key={ROUTE_SUBSCRIPTIONS_PAYMENTS}
            GPs={GeneralPermissionCode.OrganizationManagement}
                component={BillingPaymentHistory}/>
    ];
}